export default "__VITE_ASSET__5e2df334__"